// extracted by mini-css-extract-plugin
export var cardWrapper = "_55-0";